import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withLocalize } from 'locales';
import s from './NotFound.css';
import messages from './messages';

class NotFound extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    localize: PropTypes.func.isRequired,
  };

  render() {
    const { localize } = this.props;
    return (
      <div className={s.root}>
        <div className={s.container}>
          <h1>{this.props.title}</h1>
          <p>
            {localize(
              'Вибачте, але сторінки, що Ви намагалися переглянути, не існує.',
            )}
          </p>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(withLocalize(messages)(NotFound));
